import React from 'react';
import LazyMetrics from '../LazyMetrics';
import ActivityByMonth from './ActivityByMonth';
import EventActivityYear from './EventActivityYear';
import EventStatusYear from './EventStatusYear';
import EventResponseYear from './EventResponseYear';
import StudentsYear from './StudentsYear';
import InvitationsByMonth from './InvitationsByMonth';
import InvitationCreatorYear from './InvitationCreatorYear';
import InvitationDeclinerYear from './InvitationDeclinerYear';
import InvitationDeclineReasonYear from './InvitationDeclineReasonYear';
import EventSiteFilter from "@/pages/dashboard/EventSiteFilter";
import { EventsProvider } from '@/pages/dashboard/EventsContext';

export default function Events(props) {
  const { params } = props;

  return (
    <EventsProvider {...params}>
      <LazyMetrics
        // title="Events"
        columns={1}
      >
        <EventSiteFilter {...params} />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <EventStatusYear {...params} />
          <EventResponseYear {...params} />
        </div>
        <ActivityByMonth {...params} />
        <EventActivityYear {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <StudentsYear {...params} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title="Invitations - Events"
        columns={1}
      >
        <InvitationsByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <InvitationCreatorYear {...params} />
          <InvitationDeclinerYear {...params} />
        </div>
        <InvitationDeclineReasonYear {...params} />
      </LazyMetrics>
    </EventsProvider>
  );
}
